<script setup lang="ts">
import type { NewsBodyProps } from '@/types/appTypes'

const props = withDefaults(defineProps<NewsBodyProps>(), {})

const app = useNuxtApp()

let styleIdOld = ''
let sBody = null // ボディ

if (app.$isArticleOld(props.item)) {
  styleIdOld = 'id-old'
}

if (!sBody) {
  sBody = app.$getArticleBody(props.item)
  if (sBody && app.$isArticleOld(props.item)) {
    //  置換：[url=][/url],
    sBody = sBody
      .replace(/\[url=(.+?)\](.+?)\[\/url\]/g, '<a href="$1" class="c-newsFrom">$2</a>')
      .replace(/https:\/\/www.museum.or.jp\/(modules\/im\/index.php\?content_id=)/g, '/static/')
      .replace(/&toNews/g, '')
  }
}
</script>

<template>
  <div class="c-container">
    <div class="c-header">
      ニュース
      <div
        v-if="item && item.title"
        class="c-header_title"
      >
        {{ item.title }}
      </div>
      <div
        v-if="item && item.open_date"
        class="c-header_date"
      >
        (掲載日時:{{ app.$getPeriodDayLabelNoDD(item.open_date) }})
      </div>
    </div>
    <div
      v-if="sBody"
      v-bind:id="styleIdOld"
      class="c-detail"
    >
      <div
        class="c-detail_text l-blank-icon-none"
        v-html="sBody"
      />
    </div>

    <div class="c-link">
      <ShareButtons
        v-bind:title="title"
      />
    </div>
    <div class="c-pass">
      <div>
        <nuxt-link
          to="/news"
        >
          <v-btn
            variant="outlined"
            size="large"
            class="c-pass_button"
          >
            <v-icon start>
              mdi-chevron-right
            </v-icon>
            <div class="c-pass_button_text">
              ニュース一覧へ
            </div>
          </v-btn>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-container {
  width: 722px;

  @include responsive.mq_down(sp) {
    width: 100%;
  }
}

.c-header {
  margin-top: 2px;
  margin-left: -2px;
  color: var(--color_text_base);
  font-family: var(--g_font_family_NotoSansCJKjp);
  font-size: 26px;
  font-weight: 400;
  letter-spacing: -2px;

  @include responsive.mq_down(sp) {
    margin: 0 0 16px;
    font-size: 20px;
  }

  &_title {
    margin-top: 20px;
    margin-left: 1px;
    font-size: 26px;
    font-weight: 400;
    letter-spacing: 0;

    @include responsive.mq_down(sp) {
      margin: 20px 0 0;
      font-size: 20px;
    }
  }

  &_date {
    margin-top: 10px;
    color: var(--g_color_text_888888);
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    text-align: right;
  }
}

.c-image {
  width: 100%;
  height: 408px;
  margin-top: 43px;
  background-color: #ebebeb;

  @include responsive.mq_down(sp) {
    height: 52vw;
  }

  &_caption {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
    color: var(--color_text_base);
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 14px;
    line-height: 2;
  }
}

.c-detail {
  margin-top: 35px;
  margin-bottom: 30px;
  color: var(--color_text_base);
  font-family: var(--g_font_family_NotoSansCJKjp);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;

  @include responsive.mq_down(sp) {
    margin-top: 30px;
    padding: 0;
    font-size: 16px;
    line-height: 1.93;
  }

  &_text {
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 16px;
    line-height: 1.8;
  }
}

.c-link {
  display: flex;
  justify-content: center;
  padding: 45px 20px 65px 25px;

  @include responsive.mq_down(sp) {
    padding: 0;
  }

  &_attackLink {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 152px;
    height: 40px;
    margin-top: -5px;
    margin-left: -5px;
    border: 1px solid var(--color_border_control);
    border-radius: 50px;
    font-weight: bold;
    letter-spacing: -1.5px;

    @include responsive.mq_down(sp) {
      margin: 0;
    }
  }

  &_button {
    display: flex;
    margin-top: -6px;

    @include responsive.mq_down(sp) {
      margin: 20px 0;
    }

    &_border {
      min-width: 60px !important;
      min-height: 40px;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.c-related {
  margin-top: 60px;
  margin-bottom: 30px;
  padding-right: 20px;
  padding-left: 20px;

  @include responsive.mq_down(sp) {
    padding: 0;
  }

  &_header {
    display: flex;
    margin-top: 75px;
    margin-bottom: 20px;

    @include responsive.mq_down(sp) {
      margin-top: 45px;
    }

    &_source {
      color: var(--color_text_base);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 14px;
      line-height: 1.7;
    }

    &_location {
      color: var(--color_primary_link);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 15px;
      line-height: 1.65;
    }

    &_contentGroup {
      margin-top: 25px;

      &_content {
        color: var(--color_primary_link);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 14px;
        line-height: 1.7;
      }
    }
  }
}

.c-backNews {
  display: flex;
  margin-left: 20px;

  @include responsive.mq_down(sp) {
    margin-left: 0;
  }

  &::before {
    content: "\276F ";
    margin-top: 1px;
    margin-right: 10px;
    color: var(--color_primary_link);
    font-size: 18px;
  }

  &_backContent {
    color: var(--color_primary_link);
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -2px;
    line-height: 1.7;
  }

  &_backContent:hover {
    text-decoration: underline;
  }
}

.c-pass {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 50px;
  font-family: var(--g_font_family_NotoSansCJKjp);

  a {
    text-decoration: none;
  }

  @include responsive.mq_down(sp) {
    margin-top: 50px;
  }

  &_button {
    min-width: 400px !important;
    border: 2px solid var(--color_border_control);
    border-radius: 8px;
    font-family: var(--g_font_family_SawarabiGothic);
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;

    @include responsive.mq_down(sp) {
      // min-width: 200px !important;
      min-width: auto !important;
      height: auto !important;
      padding: 14px 10px !important;
    }
  }

  &_description {
    margin-top: 24px;
    font-size: 14px;
    line-height: 1.571;
    text-align: center;
  }

  a:hover & {
    &_button {
      &_text {
        text-decoration: underline;
      }
    }
  }
}

#id-old {
  .c-detail {
    margin-top: 20px;
  }

  :deep(.c-detail_text) {
    > div[style*="font-size:80%"] {
      width: 100% !important;
      font-size: 13px !important;
    }
  }
}
</style>
